// @ts-nocheck

import MainDispatcher from '../support/MainDispatcher';
import dash_api from '../support/dash_api';

import * as R from 'ramda';
import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';
import NotificationActions from '../actions/NotificationActions';
import { FETCH_LINKS_BY_QUERY } from './LinkManager/FetchLinksByQueryActions';

const errorProvider = new ErrorProvider();

export default {
  load: function () {
    MainDispatcher.dispatch({
      action: 'MARKETING_LOADING',
    });

    return dash_api.get('/v1/link/marketing').then(({ data }) => {
      MainDispatcher.dispatch({
        action: 'MARKETING_LOADED',
        links: data || [],
      });
    });
  },
  loadMore: function (id) {
    MainDispatcher.dispatch({
      action: 'MARKETING_MORE_LOADING',
      id,
    });

    return dash_api
      .get('/v1/link/marketing', {
        params: { start: id },
      })
      .then(({ data }) => {
        MainDispatcher.dispatch({
          action: 'MARKETING_MORE_LOADED',
          links: data,
        });
      });
  },
  loadOne: function (id) {
    MainDispatcher.dispatch({
      action: 'MARKETING_SINGLE_LINK_LOADING',
      id,
    });

    return dash_api
      .get('/v1/link/marketing/single', {
        params: { id },
      })
      .then(({ data }) => {
        MainDispatcher.dispatch({
          action: 'MARKETING_SINGLE_LINK_LOADED',
          link: data,
        });
      })
      .catch(() => {
        MainDispatcher.dispatch({
          action: 'MARKETING_SINGLE_LINK_LOADED',
        });
      });
  },
  updateLocally: function (link) {
    MainDispatcher.dispatch({
      action: 'MARKETING_UPDATE',
      link: link,
    });
  },
  update: function (link) {
    const formData = new FormData();
    formData.append('link', JSON.stringify(link));

    return dash_api.post(`/v1/link/marketing`, formData).then(({ data }) => {
      MainDispatcher.dispatch({
        action: 'MARKETING_UPDATE',
        link: data,
      });
    });
  },
  archiveLink: async (id, archived) => {
    try {
      const link = await dash_api.get('/v1/link/marketing/single', {
        params: { id },
      });

      const formData = new FormData();
      formData.append('link', JSON.stringify({ ...link?.data, archived: archived }));

      await dash_api.post(`/v1/link/marketing`, formData);
      NotificationActions.showNotification(`Link successfully achieved`, 'success');
      return true;
      // biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
    } catch (e) {
      NotificationActions.showNotification(`Error trying to archive link '${id}'`, 'error');
    }
  },
  saveBulk: function (links) {
    MainDispatcher.dispatch({
      action: 'MARKETING_BULK_SAVING',
    });
    // Save links in batches - max payload size is 100KB
    var MAX_REQUEST_LINKS = 50;
    var batchCount = Math.ceil(links.length / MAX_REQUEST_LINKS);

    var allLinks = [];
    var allRaw = [];
    var currentBatch = 0;
    var offset;
    var end;
    var portion;

    function performBatch() {
      if (currentBatch >= batchCount) {
        return true;
      }
      offset = MAX_REQUEST_LINKS * currentBatch;
      end = offset === 0 ? MAX_REQUEST_LINKS : MAX_REQUEST_LINKS + offset;
      portion = links.slice(offset, end);

      return dash_api
        .post('/v1/link/marketing/bulk', { links: portion })
        .then(({ data }) => {
          currentBatch++;
          R.forEach(function (res) {
            allLinks.push(res);
          }, data.links);
          R.forEach(function (res) {
            allRaw.push(res);
          }, data.raw);
          return performBatch();
        })
        .catch((err) => {
          MainDispatcher.dispatch({
            action: 'MARKETING_BULK_ERROR',
            error: errorProvider.parse(err).getMessageOrEmpty(),
          });
          throw err;
        });
    }

    return performBatch().then(function () {
      MainDispatcher.dispatch({
        action: 'MARKETING_BULK_SAVED',
        links: allLinks,
        raw: allRaw,
      });

      MainDispatcher.dispatch({
        action: FETCH_LINKS_BY_QUERY,
      });

      return { links: allLinks, raw: allRaw };
    });
  },
  deleteLink: function (id, linkName, skipDispatcher) {
    return dash_api
      .delete('/v1/link/marketing', {
        params: { id, linkName },
      })
      .then(({ data }) => {
        NotificationActions.showNotification(`Link '${linkName}' deleted`, 'success');
        if (!skipDispatcher) {
          MainDispatcher.dispatch({
            action: 'MARKETING_DELETE',
            link_id: id,
          });
        }
        return data;
      })
      .catch(() => {
        NotificationActions.showNotification(`Error trying to delete link '${linkName}'`, 'error');
        if (!skipDispatcher) {
          MainDispatcher.dispatch({
            action: 'MARKETING_DELETE',
          });
        }
      });
  },
  cancel: function () {
    MainDispatcher.dispatch({
      action: 'MARKETING_CANCEL',
    });
  },
  toggleArchived: function () {
    MainDispatcher.dispatch({
      action: 'MARKETING_TOGGLE_ARCHIVED',
    });
  },
  setFilter: function (filter) {
    MainDispatcher.dispatch({
      action: 'MARKETING_SET_FILTER',
      filter: filter,
    });
  },
  addFilter: function (key, value) {
    MainDispatcher.dispatch({
      action: 'MARKETING_ADD_FILTER',
      key: key,
      value: value,
    });
  },
  removeFilter: function (key, value) {
    MainDispatcher.dispatch({
      action: 'MARKETING_REMOVE_FILTER',
      key: key,
      value: value,
    });
  },
  setSelectedFilters: function (filters) {
    MainDispatcher.dispatch({
      action: 'MARKETING_SET_SELECTED_FILTERS',
      filters,
    });
  },
  removeAllFilters: function () {
    MainDispatcher.dispatch({
      action: 'MARKETING_REMOVE_ALL_FILTERS',
    });
  },
  setComparator: function (comparator) {
    MainDispatcher.dispatch({
      action: 'MARKETING_SET_COMPARATOR',
      comparator: comparator,
    });
  },
  setReversedOrder: function (isReversed) {
    MainDispatcher.dispatch({
      action: 'MARKETING_SET_REVERSED_ORDER',
      isReversed: isReversed,
    });
  },
  setSearchString: function (searchString) {
    MainDispatcher.dispatch({
      action: 'MARKETING_SET_SEARCH_STRING',
      searchString: searchString,
    });
  },
  setStats: function (stats) {
    MainDispatcher.dispatch({ action: 'MARKETING_SET_STATS', stats });
  },
};
